import { ReactNode } from "react";

/**
 * Site-wide section header: dot marker + display face.
 * One treatment everywhere — replaces the old blue left-stripe divs so
 * every section on every page opens the same way.
 */
export default function SectionHeading({
  children,
  sub,
  className = "",
}: {
  children: ReactNode;
  /** Optional supporting line under the heading. */
  sub?: ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <div className="flex items-start gap-3">
        <span
          className="h-2.5 w-2.5 rounded-full bg-brand-600 shrink-0 mt-[0.55em]"
          aria-hidden
        />
        <h2 className="font-display text-2xl md:text-3xl font-bold text-ink leading-snug">
          {children}
        </h2>
      </div>
      {sub && (
        <p className="text-ink-muted mt-2 ml-[22px] max-w-[65ch]">{sub}</p>
      )}
    </div>
  );
}
